import React from 'react';
import { Link } from 'react-router-dom';
import { FiShield, FiTool, FiBook } from 'react-icons/fi';

const services = [
    {
        icon: <FiTool size={32} className="text-red-500 mb-4" />,
        title: "Cybersecurity Training",
        description: "On-premise cyber labs with hands-on training in CTF competitions, incident handling, red teaming, and VAPT.",
        items: [
            "Jeopardy & Attack-Defense CTFs",
            "Table Top Exercises",
            "Incident Handling Training",
            "Boot2Root Challenges"
        ],
    },
    {
        icon: <FiShield size={32} className="text-red-500 mb-4" />,
        title: "Red Team Services",
        description: "Professional red teaming and vulnerability assessment & penetration testing services for organizations of all sizes.",
        items: [
            "Web Application Pentesting",
            "Mobile App Security Testing",
            "API Security Assessment",
            "Infrastructure & Active Directory"
        ],
    },
    {
        icon: <FiBook size={32} className="text-red-500 mb-4" />,
        title: "Akademi Siber",
        description: "Educational platform in Bahasa Indonesia with gamified cybersecurity learning. Brought to you by SiberLab ID, in partnership with REDAC7D.",
        items: [
            "Hands-on CTF Style Learning",
            "Full Bahasa Indonesia Content",
            "Free & Premium Modules",
            "Student-Friendly Pricing"
        ],
    },
];

const Services = () => {
    return (
        <section id="services" className="bg-[#121212] text-white px-6 md:px-16 py-20">
            <div className="text-center mb-12">
                <h2 className="text-3xl font-bold mb-2">
                    <span className="text-white">Our</span> <span className="text-red-500">Services</span>
                </h2>
                <p className="text-gray-400 max-w-2xl mx-auto">
                    Comprehensive cybersecurity solutions tailored to your needs. From training to active defense, we've got you covered.
                </p>
            </div>

            <div className="grid gap-8 md:grid-cols-3">
                {services.map((service, index) => (
                    <div
                        key={index}
                        className="bg-[#1a1a1a] p-6 rounded-lg shadow-lg border border-gray-700 hover:border-red-500 transition"
                        data-aos="zoom-in"
                        data-aos-delay={index * 100}
                        data-aos-duration="800"
                    >
                        <div className="flex flex-col items-start">
                            {service.icon}
                            <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
                            <p className="text-gray-400 mb-4">{service.description}</p>
                            <ul className="text-sm text-gray-300 space-y-1 mb-4 list-disc list-inside">
                                {service.items.map((item, idx) => (
                                    <li key={idx}>{item}</li>
                                ))}
                            </ul>

                            {/* Conditionally render Link only for the first card */}
                            {index === 0 ? (
                                <Link
                                    to="/services/cybersecurity-training"
                                    className="text-red-500 hover:underline font-semibold"
                                >
                                    Learn More →
                                </Link>
                            ) : (
                                <a href="#!" className="text-red-500 hover:underline font-semibold">
                                    Learn More →
                                </a>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Services;
